import React from 'react'
import { COLORES } from '../../../../../config/colores'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import TablaCamionesEnPlaya from '../../../../Camiones/containers/listados/camionesEnPlaya/containers/TablaCamionesEnPlaya'
import TablaCamionesEntrePlayaCalado from '../../../../Tablas/camionesEntrePlayaCalado/containers/TablaCamionesEntrePlayaCalado'
import TablaCamionesCalados from '../../../../Camiones/containers/listados/camionesCalados/containers/TablaCamionesCalados'
import TablaCamionesListosParaBruto from '../../../../Camiones/containers/listados/camionesListosParaBruto/containers/TablaCamionesListosParaBruto'
import TablaCamionesEntreBrutoYDestare from '../../../../Camiones/containers/listados/camionesEntreBrutoYDestare/containers/TablaCamionesEntreBrutoYDestare'
import TablaCamionesDescargados from '../../../../Camiones/containers/listados/camionesDescargados/containers/TablaCamionesDescargados'
import TablasCircuitoTotalizadores from '../containers/TablasCircuitoTotalizadores'
import TablaCamionesSinCupo from '../../../../Camiones/containers/listados/camionesSinCupo/containers/TablaCamionesSinCupo'
import CartasDePorteVetadas from '../../../../CartaDePorte/containers/CartasDePorteVetadas'
import { clavesCereales } from '../../../../../config/cereales'

export const COLUMNS_CDMD_EXPORTADOR_CEREAL = [
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      customBodyRender: variedad => {
        return ((variedad.trim() === 'UNDEF') ? '- ' : variedad)
      }
    }
  },
  {
    name: 'totalSinDescargar',
    label: 'Sin descargar',
    options: {
      filter: false,
      sort: false,
      total: true,
      totalFloat: 'right',
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: '0',
          //   background: COLORES.grey.light,
          zIndex: 100,
          textAlign: 'right'
        }
      }),
      setCellProps: () => ({
        style: {
          float: 'right',
          right: 0,
          textAlign: 'right',
          background: 'inherit'
        }
      })
    }
  },
  {
    name: 'totalSinDescargarPeso',
    label: '(Kg.)',
    options: {
      filter: false,
      sort: false,
      total: true,
      customBodyRender: (total) => <>{total} kg.</>,
      setCellProps: () => ({
        style: {
          left: 0
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          //    background: COLORES.grey.light,
        }
      })
    }
  },
  {
    name: 'descargados',
    label: 'Descargados',
    options: {
      filter: false,
      sort: false,
      total: true,
      totalFloat: 'right',
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: '0',
          //  background: COLORES.grey.mediumLight,
          zIndex: 100,
          textAlign: 'right'
        }
      }),
      setCellProps: () => ({
        style: {
          float: 'right',
          right: 0,
          textAlign: 'right'
        }
      })
    }
  },
  {
    name: 'descargadosPeso',
    label: '(Kg.)',
    options: {
      filter: false,
      sort: false,
      total: true,
      setCellHeaderProps: () => ({
        style: {
          //     background: COLORES.grey.mediumLight,
        }
      }),
      customBodyRender: (total) => {
        return <div>{total} kg.</div>
      }
    }
  },
  {
    name: 'total',
    label: 'Total',
    options: {
      filter: false,
      sort: false,
      total: true,
      totalFloat: 'right',
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: '0',
          background: COLORES.grey.dark,
          color: 'white',
          zIndex: 100,
          textAlign: 'right'
        }
      }),
      setCellProps: () => ({
        style: {
          float: 'right',
          right: 0,
          width: '100%',
          textAlign: 'right',
          background: COLORES.grey.dark,
          color: 'white'
        }
      })
    }
  },
  {
    name: 'totalPeso',
    label: '(Kg.)',
    options: {
      filter: false,
      sort: false,
      total: true,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'rigth',
          background: COLORES.grey.dark,
          color: 'white'
        }
      }),
      setCellProps: () => ({
        style: {
          background: COLORES.grey.dark,
          color: 'white'
        }
      })
    }
  }
]

export function getColumnasCamionesEnCircuito (autodescargables = false, showVetadas = false) {
  return ([
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: false,
        sort: false,
        filterType: 'checkbox',
        sticky: true,
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            background: COLORES.grey.light,
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            background: 'white',
            zIndex: 101
          }
        })
      }
    },

    {
      name: 'cerealVariedad',
      label: 'Variedad',
      options: {
        filter: false,
        sort: false,
        customBodyRender: variedad => {
          return ((variedad.trim() === 'UNDEF') ? ' - ' : variedad)
        }
      }
    },

    {
      name: 'entry',
      label: 'En playa',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['totalPlayaDeCamionesAutodescargables'] : entry['totalPlayaDeCamiones']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : []
            },
            {
              name: 'cerealVariedad',
              filterList: (entry['cerealVariedad'] !== '--------' && entry['cerealVariedad'].trim() !== 'UNDEF') ? [entry['cerealVariedad']] : [' - ']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Camiones en playa'
                content={<TablaCamionesEnPlaya filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Playa-Calado',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['entrePlayaYCaladoAutodescargables'] : entry['entrePlayaYCalado']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : [' - ']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Camiones entre playa y calado'
                content={<TablaCamionesEntrePlayaCalado filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Calados autorizados',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['caladoSinPesarAutorizadosAutodescargables'] : entry['caladoSinPesarAutorizados']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : []
            },
            {
              name: 'estadoAutorizacion',
              filterList: ['Autorizado']
            },
            {
              name: 'cerealVariedad',
              filterList: (entry['cerealVariedad'] !== '--------' && entry['cerealVariedad'].trim() !== 'UNDEF') ? [entry['cerealVariedad']] : [' - ']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Camiones calados autorizados'
                content={<TablaCamionesCalados filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Calados pendientes',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['caladoSinPesarPendientesAutodescargables'] : entry['caladoSinPesarPendientes']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : []
            },
            {
              name: 'estadoAutorizacion',
              filterList: ['Pendiente']
            },
            {
              name: 'cerealVariedad',
              filterList: (entry['cerealVariedad'] !== '--------' && entry['cerealVariedad'].trim() !== 'UNDEF') ? [entry['cerealVariedad']] : [' - ']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Camiones calados pendientes'
                content={<TablaCamionesCalados filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Calado-Bruto',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['entreCaladoYBrutoAutodescargables'] : entry['entreCaladoYBruto']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : []
            },
            {
              name: 'cerealVariedad',
              filterList: (entry['cerealVariedad'] !== '--------' && entry['cerealVariedad'].trim() !== 'UNDEF') ? [entry['cerealVariedad']] : [' - ']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Camiones entre calado y bruto'
                content={<TablaCamionesListosParaBruto filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Bruto-Destare',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['entreBrutoYDestareAutodescargables'] : entry['entreBrutoYDestare']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : []
            },
            {
              name: 'cerealVariedad',
              filterList: (entry['cerealVariedad'] !== '--------' && entry['cerealVariedad'].trim() !== 'UNDEF') ? [entry['cerealVariedad']] : [' - ']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Camiones entre bruto y destare'
                content={<TablaCamionesEntreBrutoYDestare filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Descargados',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['descargadosAutodescargables'] : entry['descargados']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : []
            },
            {
              name: 'cerealVariedad',
              filterList: (entry['cerealVariedad'] !== '--------' && entry['cerealVariedad'].trim() !== 'UNDEF')
                ? [entry['cerealVariedad']] : ['-']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Camiones descargados'
                content={<TablaCamionesDescargados
                  filtroInicial={filtroInicial}
                  hideDatePicker
                />
                }
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Total',
      options: {
        filter: false,
        sort: false,
        total: true,
        sticky: true,
        stickyRight: true,
        setCellProps: () => ({
          style: {
            position: 'sticky',
            right: 0,
            zIndex: 100,
            background: COLORES.grey.dark
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            position: 'sticky',
            right: 0,
            color: 'white',
            background: COLORES.grey.dark,
            zIndex: 101
          }
        }),
        customBodyRender: (entry) => {
          const total = autodescargables ? entry['totalAutodescargables'] : entry['total']
          return (
            (total > 0 && !autodescargables)
              ? <TableValueAction
                value={total}
                textColor='white'
                title='Camiones en circuito'
                content={<TablasCircuitoTotalizadores />}
              />
              : <div style={{ fontWeight: 'bold', color: 'white' }}>{total}</div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Cupo no vigente',
      options: {
        filter: false,
        sort: false,
        total: true,
        totalBackground: 'white',
        totalColor: COLORES.grey.dark,
        setCellProps: () => ({
          style: {
            background: 'white'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            background: 'white',
            color: '#fb3f3f'
          }
        }),
        customBodyRender: (entry) => {
          const value = autodescargables ? entry['ingresoSincupoAutodescargables'] : entry['ingresoSincupo']
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: entry['nombreCereal'] !== 'TOTAL' ? [entry['nombreCereal'].trim()] : []
            },
            {
              name: 'cerealVariedad',
              filterList: (entry['cerealVariedad'] !== '--------' && entry['cerealVariedad'].trim() !== 'UNDEF') ? [entry['cerealVariedad']] : ['-']
            },
            {
              name: 'autodescargable',
              filterList: autodescargables ? ['Si'] : []
            }
          ]

          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Cupo no vigente'
                textColor='#fb3f3f'
                content={<TablaCamionesSinCupo filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: '#fb3f3f',
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'entry',
      label: 'Vetadas',
      options: {
        filter: false,
        sort: true,
        total: true,
        totalBackground: 'white',
        totalColor: COLORES.grey.dark,
        display: showVetadas && !autodescargables,
        setCellProps: () => ({
          style: {
            background: 'white'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            background: 'white',
            color: '#fb3f3f'
          }
        }),
        customBodyRender: (entry) => {
          const value = entry['cantidadVetadas']
          const cereal = entry['nombreCereal']
          const filtroInicial = cereal !== 'TOTAL' ? [clavesCereales[cereal.replace(/\s+/g, '')]] : []
          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Cartas de porte vetadas'
                textColor='#fb3f3f'
                content={<CartasDePorteVetadas filtroInicial={filtroInicial} />}
              />
              : <div style={{
                color: '#fb3f3f',
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }

      }
    }
  ])
}

export const COLUMNS_CDMD_CEREAL_PESO_TOTAL = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        const noVariedad = variedad.trim() === 'UNDEF' || variedad.trim() === ''
        return (noVariedad ? '-' : <>{variedad}</>)
      }
    }
  },
  {
    name: 'totalSinDescargar',
    label: 'Sin descargar',
    options: {
      filter: false,
      sort: false,
      total: true,
      totalFloat: 'right',
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: '0',
          // background: COLORES.grey.light,
          zIndex: 100,
          textAlign: 'right'
        }
      }),
      setCellProps: () => ({
        style: {
          float: 'right',
          right: 0
        }
      })
    }
  },
  {
    name: 'totalSinDescargarPeso',
    label: '(Kg.)',
    options: {
      filter: false,
      sort: false,
      total: true,
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          //     background: COLORES.grey.light,
          zIndex: 100
        }
      })
    }
  },
  {
    name: 'descargados',
    label: 'Descargados',
    options: {
      filter: false,
      sort: false,
      total: true,
      totalFloat: 'right',
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          right: '0',
          //   background: COLORES.grey.light,
          zIndex: 100,
          textAlign: 'right'
        }
      }),
      setCellProps: () => ({
        style: {
          float: 'right',
          right: 0,
          textAlign: 'right'
        }
      })
    }
  },
  {
    name: 'descargadosPeso',
    label: '(Kg.)',
    options: {
      filter: false,
      sort: false,
      total: true,
      setCellHeaderProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          // background: COLORES.grey.light,
          zIndex: 100
        }
      })
    }
  }
]
